import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { ChevronM } from "../../../../overview/info-tables/ChevronM";
import CheckIcon from "../../../../../icons/check.icon";
import styles from "./sales-rep-dropdown.module.scss";

const salesReps = [
  "Ellie James",
  "John Smith",
  "Sarah Johnson",
  "Mike Davis",
];

export const SalesRepDropdown = ({ id, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleItemClick = (rep) => {
    if (onChange) {
      onChange(rep);
    }
    setIsOpen(false);
  };

  const handleToggleClick = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  return (
    <Dropdown
      show={isOpen}
      onToggle={() => setIsOpen(!isOpen)}
      className={styles.salesRepDropdown}
    >
      <Dropdown.Toggle
        as="div"
        className={styles.salesRepSelectToggle}
        onClick={handleToggleClick}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-label="Select sales representative"
        id={id}
      >
        <div className={styles.salesRepSelectContent}>
          <span className={styles.salesRepSelectText}>
            {value}
          </span>
        </div>
        <div className={styles.salesRepSelectButton}>
          <ChevronM className={styles.chevronIcon} width={24} height={14} />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className={styles.dropdownMenu}>
        <ul className={styles.menuList} role="listbox">
          {salesReps.map((rep) => (
            <li
              key={rep}
              role="option"
              aria-selected={rep === value}
              onClick={() => handleItemClick(rep)}
              className={styles.menuItem}
            >
              <div className={styles.checkIconWrapper}>
                {rep === value && (
                  <CheckIcon className={styles.checkIcon} width={16} height={16} fill="#616778" />
                )}
              </div>
              <div className={styles.menuItemText}>
                {rep}
              </div>
            </li>
          ))}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
};

